import { useState, useEffect } from 'react';
import { playersApi } from '../api/client';
import PlayerCard from '../components/PlayerCard';
import SEO, { SITE_URL } from '../components/SEO';

const POSITIONS = ['', 'GK', 'CB', 'LB', 'RB', 'CDM', 'CM', 'CAM', 'LW', 'RW', 'ST'];
const STATUSES = [{ value: '', label: 'All' }, { value: 'active', label: 'Active' }, { value: 'seeking', label: 'Seeking club' }, { value: 'retired', label: 'Retired' }];

export default function Players() {
  const [players, setPlayers] = useState([]);
  const [position, setPosition] = useState('');
  const [status, setStatus] = useState('');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (position) params.position = position;
    if (status) params.status = status;
    if (search) params.search = search;
    playersApi.list(params).then(r => { setPlayers(r.data.results || r.data); setLoading(false); });
  }, [position, status, search]);

  return (
    <div style={{ padding: '2rem 0' }}>
      <div className="container">
        <SEO
          title="Talent Directory — African Players"
          description="Discover active players, rising stars and retired legends across African football. Search by position, status and nationality."
          url={`${SITE_URL}/players`}
          jsonLd={{
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: 'African Football Talent Directory',
            description: 'Active players, rising stars and retired legends across African football.',
            url: `${SITE_URL}/players`,
          }}
        />
        <h1 style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>Talent Directory</h1>
        <p style={{ color: '#666', fontFamily: 'sans-serif', marginBottom: '2rem' }}>Active players, rising stars, and retired legends across Africa.</p>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', marginBottom: '2rem' }}>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search by name, club, country…"
            style={{ flex: '1 1 220px', padding: '0.6rem 1rem', border: '1px solid #e5e5e5', borderRadius: 8, fontFamily: 'sans-serif', fontSize: '0.875rem', outline: 'none' }} />
          <select value={position} onChange={e => setPosition(e.target.value)}
            style={{ padding: '0.6rem 1rem', border: '1px solid #e5e5e5', borderRadius: 8, fontFamily: 'sans-serif', fontSize: '0.875rem', outline: 'none', background: 'white' }}>
            {POSITIONS.map(p => <option key={p} value={p}>{p || 'All positions'}</option>)}
          </select>
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
            {STATUSES.map(s => (
              <button key={s.value} onClick={() => setStatus(s.value)} className="btn"
                style={{ padding: '0.4rem 1rem', fontFamily: 'sans-serif', background: status === s.value ? '#1a6b45' : 'transparent', color: status === s.value ? 'white' : '#444', border: '1px solid #e5e5e5' }}>
                {s.label}
              </button>
            ))}
          </div>
        </div>
        {loading ? <p style={{ fontFamily: 'sans-serif', color: '#999' }}>Loading…</p> : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1rem' }}>
            {players.map(p => <PlayerCard key={p.id} player={p} />)}
            {players.length === 0 && <p style={{ fontFamily: 'sans-serif', color: '#999' }}>No players found.</p>}
          </div>
        )}
      </div>
    </div>
  );
}
